/**
 * API CompagnonCPS
 * API pour le connecteur CompagnonCPS
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ErrorSessionCPX { 
    code: ErrorSessionCPX.CodeEnum;
    message: string;
}
export namespace ErrorSessionCPX {
    export type CodeEnum = 'CARTE_ARRACHEE' | 'SESSION_EXPIREE' | 'AUCUNE_SESSION' | 'SESSION_NON_VALIDE';
    export const CodeEnum = {
        CarteArrachee: 'CARTE_ARRACHEE' as CodeEnum,
        SessionExpiree: 'SESSION_EXPIREE' as CodeEnum,
        AucuneSession: 'AUCUNE_SESSION' as CodeEnum,
        SessionNonValide: 'SESSION_NON_VALIDE' as CodeEnum
    };
}


